export const COOKIES_ENABLED = 'cookiesEnabled'

export const SCREEN_LOADING = 'screenLoading'

export const CHANGE_OBJECT_PROPERTY = 'changeObjectProperty'

export const CURRENT_ADDRESS_SAME_MEDAVIE = 'currentAddressSameMedavie'

export const LIST_ADD = 'listAdd'
export const LIST_EDIT = 'listEdit'
export const LIST_DELETE = 'listDelete'
export const LIST_CLEAR = 'listClear'

export const CLEAR_ALL = 'clearAll'
export const CLEAR_APP_DATA = 'clearAppData'

export const SET_EDIT_NS_IDENTIFIER_NUMBER = 'setEditNSIdentifierNumber'
export const SET_EDIT_JOINT_MASTER_NUMBER = 'setEditJointMasterNumber'
export const SET_EDIT_BUSINESS_MASTER_NUMBER = 'setEditBusinessMasterNumber'

export const SET_NEW_ADDRESS_MAILING_ADDRESS_SAME = 'setNewAddressMailingAddressSame'
export const SET_NEW_MAILING_ADDRESS_PROPERTY = 'setNewMailingAddressProperty';
export const SET_CURRENT_ADDRESS_MEDAVIE_DIFFERENT = 'setCurrentAddressMedavieDifferent';